import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export const Delivered = () => {
    return (
        <DotLottieReact
            src="https://lottie.host/66700b43-a0cd-4f43-95be-be32e27627de/pzhaIAT4eX.lottie"
            loop
            autoplay
        />
    );
};
